import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { AccountMembershipRole, Module, useRegenerateTeamMemberTokenMutation, useGetTeamMemberLinkQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'InviteTeamMember',
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var shareLink = ref('');
    var inviteRole = ref(AccountMembershipRole.Editor);
    var canInviteReviewer = computed(function () {
      return (props.account.modules || []).includes(Module.Review);
    });
    var effectiveInviteRole = computed(function () {
      return canInviteReviewer.value ? inviteRole.value : AccountMembershipRole.Editor;
    });
    var linkVariables = computed(function () {
      return {
        id: props.account.id,
        role: effectiveInviteRole.value
      };
    });
    var _useGetTeamMemberLink = useGetTeamMemberLinkQuery(linkVariables),
      result = _useGetTeamMemberLink.result,
      onResult = _useGetTeamMemberLink.onResult,
      refetch = _useGetTeamMemberLink.refetch,
      linkLoading = _useGetTeamMemberLink.loading;
    onResult(function () {
      var _result$value$getTeam, _result$value;
      shareLink.value = window.location.host + ((_result$value$getTeam = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getTeamMemberLink) !== null && _result$value$getTeam !== void 0 ? _result$value$getTeam : '');
    });
    var onRoleChange = function onRoleChange(role) {
      if (!canInviteReviewer.value) {
        inviteRole.value = AccountMembershipRole.Editor;
        return;
      }
      inviteRole.value = role || AccountMembershipRole.Editor;
      refetch();
    };
    var _useRegenerateTeamMem = useRegenerateTeamMemberTokenMutation(),
      mutate = _useRegenerateTeamMem.mutate,
      onDone = _useRegenerateTeamMem.onDone,
      loading = _useRegenerateTeamMem.loading;
    onDone(function (result) {
      var _result$data$regenera, _result$data;
      shareLink.value = window.location.host + ((_result$data$regenera = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.regenerateTeamMemberToken) !== null && _result$data$regenera !== void 0 ? _result$data$regenera : '');
      window.$nuxt.$emit('userMsg');
    });
    var triggerNewLink = function triggerNewLink(dialog) {
      mutate({
        id: props.account.id
      }).then(function () {
        // After regenerating the underlying token, refetch the link for the current role.
        refetch();
        dialog.value = false;
      });
    };
    return {
      __sfc: true,
      props: props,
      shareLink: shareLink,
      inviteRole: inviteRole,
      canInviteReviewer: canInviteReviewer,
      effectiveInviteRole: effectiveInviteRole,
      linkVariables: linkVariables,
      result: result,
      onResult: onResult,
      refetch: refetch,
      linkLoading: linkLoading,
      onRoleChange: onRoleChange,
      mutate: mutate,
      onDone: onDone,
      loading: loading,
      triggerNewLink: triggerNewLink
    };
  }
});